import { render, staticRenderFns } from "./IconTag.vue?vue&type=template&id=c80d2874&"
import script from "./IconTag.vue?vue&type=script&lang=js&"
export * from "./IconTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports